import React from "react";
import { useTranslation } from "react-i18next";

const BoundaryFallback = ({ error, resetErrorBoundary }) => {
  const { t: translate, i18n } = useTranslation();

  return (
    <div role="alert">
      <p className="text-primary-900">{translate("error-boundary.message")}</p>
      <span className="text-red-600">{error.message}</span>
    </div>
  );
};

export default BoundaryFallback;
